"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DisputeReason = void 0;
var DisputeReason;
(function (DisputeReason) {
    DisputeReason[DisputeReason["DRIVER_ARRIVED_LATE"] = 0] = "DRIVER_ARRIVED_LATE";
    DisputeReason[DisputeReason["DRIVER_ARRIVED_EARLY"] = 1] = "DRIVER_ARRIVED_EARLY";
    DisputeReason[DisputeReason["POOR_DELIVERY_EXECUTION"] = 2] = "POOR_DELIVERY_EXECUTION";
    DisputeReason[DisputeReason["DRIVER_BEHAVIOR_COMPLAINT"] = 3] = "DRIVER_BEHAVIOR_COMPLAINT";
    DisputeReason[DisputeReason["FLEET_CANCELLED_AFTER_ORDER_PREP"] = 4] = "FLEET_CANCELLED_AFTER_ORDER_PREP";
    DisputeReason[DisputeReason["DRIVER_NEVER_ARRIVED_TO_PICKUP"] = 5] = "DRIVER_NEVER_ARRIVED_TO_PICKUP";
    DisputeReason[DisputeReason["DRIVER_NEVER_ARRIVED_TO_DROPOFF"] = 6] = "DRIVER_NEVER_ARRIVED_TO_DROPOFF";
    DisputeReason[DisputeReason["OTHER"] = 100] = "OTHER";
})(DisputeReason || (exports.DisputeReason = DisputeReason = {}));
//# sourceMappingURL=dispute.js.map